// NPM imports
import React from "react";
import { Tooltip } from "@revvsales/components";

// Internal Imports
import { GRID } from "../../../../constants";
import { numberForamting } from "../../../../utils/globalUtils";

// Destructuring
const { PRICING_METHODS } = GRID;

export default function BasePriceNotifier(props) {
  const {
    currencySymbol,
    editable,
    isBasePriceDynamic,
    readOnly,
    rowMeta,
    value,
  } = props;
  let toolTipText = "";
  if (isBasePriceDynamic) {
    if (
      rowMeta &&
      rowMeta.pricingData &&
      rowMeta.pricingData.type !== PRICING_METHODS.NON_LINEAR &&
      rowMeta.pricingData.type !== PRICING_METHODS.DIY_PRICING
    ) {
      toolTipText = "Base price is dependant on total quantity selected";
    } else if (
      rowMeta &&
      rowMeta.pricingData &&
      rowMeta.pricingData.value &&
      rowMeta.pricingData.isAdhoc
    ) {
      toolTipText =
        "This is an ad-hoc SKU. Click the green cell under QUANTITY to enter effort for resources";
    }
    return (
      <Tooltip placement="top" overlay={<div>{toolTipText}</div>}>
        <div
          className={`rs-cell is-currency dependencynotify-pin ${
            editable && !readOnly ? "is-editable" : ""
          }`}
          onClick={() => editable && !readOnly && props.onClick()}
          onKeyPress={() => null}
          role="button"
          tabIndex="0">
          {numberForamting(value, currencySymbol)}
        </div>
      </Tooltip>
    );
  }
  return (
    <div
      className={`rs-cell is-currency ${
        editable && !readOnly ? "is-editable" : ""
      }`}
      onClick={() => editable && !readOnly && props.onClick()}
      onKeyPress={() => null}
      role="button"
      tabIndex="0">
      {numberForamting(value, currencySymbol)}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/commonComponents/RevvGrid/Display/Renderer/BasePriceNotifier.js